import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../PageShell";
import { Reveal } from "../UIKit";

export default function AboutPage({ onAuthClick }) {
  return (
    <PageShell
      onAuthClick={onAuthClick}
      eyebrow="About us"
      title="Built by one founder."
      lede="Bellboy is a pre-seed startup building security and society-management software for India's housing societies."
      sceneMode="badge"
      seoTitle="About — Bellboy Security & Society Management App"
      seoDescription="About Bellboy and founder Tejeshwar Mishra — a pre-seed startup building security and society-management software for India's housing societies."
    >
      <section className="page-section">
        <div className="about-grid">
          <Reveal className="about-card">
            <h3>The mission</h3>
            <p>
              Automate the manual work underneath every housing society's visitor log, billing, and helpdesk —
              and keep the data it produces on the society's own server, not a corporate cloud.
            </p>
          </Reveal>
          <Reveal delay={100} className="about-card">
            <h3>The stage</h3>
            <p>
              Bellboy is pre-seed and small by design — every part of the product, from the gate hardware
              integration to the WhatsApp bot, is built end-to-end by its founder.
            </p>
          </Reveal>
        </div>
        <Reveal delay={160} className="founder-row">
          <div className="founder-avatar">T</div>
          <div>
            <strong style={{ display: "block", fontSize: 17, color: "var(--ink)" }}>Tejeshwar Mishra</strong>
            <span style={{ fontSize: 14, fontWeight: 700, opacity: 0.8 }}>Founder, Bellboy Residential Technologies</span>
          </div>
        </Reveal>
        <Reveal delay={200}>
          <Link to="/" className="section-btn">Back to Bellboy home →</Link>
        </Reveal>
      </section>
    </PageShell>
  );
}
